import { FC } from "react";

import "./NormalItem.scss";
import { Module } from "../../../../types/CoursesTypes";

const NormalItem: FC<Module> = ({ title, direction, subs }) => {
  const publicUrl = process.env.PUBLIC_URL;
  return (
    <li key={title} className={`list-item ${direction}`}>
      {title && (
        <p
          className="list-item__title"
          dangerouslySetInnerHTML={{ __html: `${title}` }}
        ></p>
      )}
      <img
        className="list-item__img"
        src={`${publicUrl}/img/course/icons/check-module.svg`}
        alt={title}
      />
    </li>
  );
};

export default NormalItem;
